export const CAMPAIGN_GOALS = [
  { value: "increase_service_revenue", label: "Increase service revenue" },
  { value: "increase_retail_revenue", label: "Increase retail products revenue" },
  { value: "increase_reviews", label: "Increase reviews" },
  { value: "increase_client_retention", label: "Increase client retention" },
  { value: "increase_booking_rate", label: "Increase booking rate (fill slow days)" },
  { value: "increase_new_client_referrals", label: "Increase new client referrals" },
  { value: "increase_client_satisfaction", label: "Increase client satisfaction (follow-up)" },
];

export const CAMPAIGN_TOOLTIPS = {
  goal:
    "A marketing goal helps you pick the right message and measure success.",
  recency:
    "Recency filters look at the salon's local time to find recent or lapsed clients.",
  frequency:
    "Frequency filters count visits in the selected window (salon local time).",
  revenue:
    "Revenue filters use ticket totals to find higher-value clients.",
  tracking:
    "Open rate shows how many recipients opened. Click rate shows how many clicked.",
  attribution:
    "Attribution window is how many days after send we count bookings or revenue.",
  unsubscribe:
    "Marketing emails must include a one-click unsubscribe link.",
};

export const CAMPAIGN_HELP_SECTIONS = [
  {
    heading: "Step-by-step",
    bullets: [
      "Goal -> Template -> Audience -> Preview -> Send -> Track -> Improve",
      "Pick a clear goal and keep the offer simple.",
    ],
  },
  {
    heading: "Filter examples",
    bullets: [
      "Lapsed clients: not visited in 90 days",
      "High value: lifetime spend >= 500",
      "Slow days: recent visits but not in the last 14 days",
    ],
  },
  {
    heading: "Tips",
    bullets: [
      "Send during business hours in your salon's timezone.",
      "Keep subject lines short and benefit-focused.",
      "Target lapsed clients with a friendly reminder.",
      "Use A/B tests later to refine subject lines.",
    ],
  },
  {
    heading: "Metrics explained",
    bullets: [
      "Open rate = unique opens / delivered",
      "Click rate = unique clicks / delivered",
      "Revenue and bookings are counted within the attribution window.",
    ],
  },
];
